<template>
  <loading-area id="connection-loading" theme="dark" v-show="isOffline">
    <div class="connection-loading-icon" slot="icon">
      <svg-loader src="/assets/images/offline.svg"></svg-loader>
    </div>

    <p v-for="message in $t('errorMessages.offlineMessage')" :key="message">{{ message }}</p>
  </loading-area>
</template>

<script>
  export default {
    name: 'connection-loading',
    data: () => ({
      statusType: 'online'
    }),
    computed: {
      isOffline () {
        return this.statusType === 'offline'
      }
    },
    methods: {
      updateConnectionStatus ({ type }) {
        this.statusType = type
      }
    },
    mounted () {
      window.addEventListener('online', this.updateConnectionStatus)
      window.addEventListener('offline', this.updateConnectionStatus)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .connection-loading-icon {
    .svg-image {
      path:first-child {
        animation: up 1s ease-in-out infinite;
      }

      path:last-child {
        animation: down 1s ease-in-out infinite;
      }
    }
  }

  @keyframes up {
    0% {
      transform: translate3d(0, 0, 0)
    }
    50% {
      transform: translate3d(8px, -8px, 0);
    }
    100% {
      transform: translate3d(0, 0, 0)
    }
  }

  @keyframes down {
    0% {
      transform: translate3d(0, 0, 0)
    }
    50% {
      transform: translate3d(-8px, 8px, 0);
    }
    100% {
      transform: translate3d(0, 0, 0)
    }
  }
</style>
